<template>
    <div>
        <table class="search-result-table"
               v-on:mousemove="displayFloat"
               v-on:mouseover="showFloat"
               v-on:mouseout="hideFloat"
        >
            <tr class="table-header-row">
                <th
                        v-for="item in headers"
                        :key="item.value"
                        :style="{'width':item.width,'textAlign':item.align || 'left'}"
                >
                    {{ item.text }}
                </th>
            </tr>
            <tr
                    v-show="tableData.length > 0"
                    v-for="(item2,index) in tableData"
                    :key="index" class="table-result-row"
            >
                <td
                        v-for="(context,j) in headers"
                        :key="j"
                        :style="{'textAlign':context.align || 'left','padding-top': 0,'padding-bottom': 0}"
                >
                    {{item2[context.value]}}
                    <slot
                        :name="context.value"
                        :data="item2"
                    ></slot>
                    <div v-if="enableFloating" class="floating">待批：{{hiddenKey}}</div>
                </td>
            </tr>
            <tr v-show="tableData.length == 0">
                <td :colspan="headers.length" style="text-align:center;padding-top:10px;">
                    暂无数据
                </td>
            </tr>
        </table>
        <div v-if="length > 0" class="pagination" :value="pageNum3">
            <BBtnPrimary class="nav-button" size="small" btn-txt="上一页" :clicked="pageup"/>
            <div v-for="(i,index3) in pages" :key="index3+i*i">
                <input v-if="i !='...'" class="radio-hidden" type="radio" name="num2" :id="'pagnum2'+i" :value="i"
                       v-model="pageNum3"
                />
                <label
                        :class="[i != '...' ? 'number-button':'blank-button']"
                        :for="'pagnum2'+i">{{i}}
                </label>
            </div>
            <BBtnPrimary class="nav-button" size="small" btn-txt="下一页" :clicked="pagedown"/>
        </div>
    </div>
</template>

<script>
    import BBtnPrimary from "./BBtnPrimary";

    export default {
        name: "Table",
        components: {
            BBtnPrimary
        },
        props: {
            // table数据
            tableData: Array,
            // table头
            headers: Array,
            // 每页几条
            length: Number,
            //
            totalVisible: Number,
            // 页码
            pageNum1: Number,
            // 是否开启悬浮窗
            enableFloating: Boolean,
            //参数
            hiddenKey: Number,
        },
        data() {
            return {
                pages: [],
                pageNum3: this.pageNum1,
            }
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            pageNum(newVal, oldVal) {
                this.pageNum3 = newVal
            },
            pageNum3() {
                this.$emit("input", this.pageNum3)
                this.calculateLimits()
            },
            length() {
                this.calculateLimits()
            }
        },
        mounted() {
            this.calculateLimits();
        },
        methods: {
            pagedown() {
                this.pageNum3++;
                if (this.pageNum3 > this.length) {
                    this.pageNum3 = this.length;
                }
            },
            pageup() {
                this.pageNum3--;
                if (this.pageNum3 < 1) {
                    this.pageNum3 = 1;
                }
            },
            calculateLimits() {
                this.pages = [];
                if (this.length <= this.totalVisible || this.totalVisible < 7) {
                    for (var i = 1; i <= this.length; i++) {
                        this.pages.push(i);
                    }
                    return;
                }
                let upperlimit;
                let lowerlimit = upperlimit = Math.min(this.pageNum3, this.length);
                for (var b = 1; b < this.totalVisible && b < this.length;) {
                    if (lowerlimit > 1) {
                        lowerlimit--;
                        b++;
                    }
                    if (b < this.totalVisible && upperlimit < this.length) {
                        upperlimit++;
                        b++;
                    }
                }
                this.pages.push(1);
                for (var a = 1; a <= this.length; a++) {
                    if (a > lowerlimit && a < upperlimit) {
                        this.pages.push(a);
                    }
                }
                this.pages.push(this.length);
                if (this.pages[1] !== 2) {
                    this.pages[1] = '...';
                }
                if (this.pages[this.totalVisible - 2] !== this.length - 1) {
                    this.pages[this.totalVisible - 2] = '...';
                }
            },
            // Get X and Y position of the elm (from: vishalsays.wordpress.com/ )
            getXYpos(elm) {
                let x = elm.offsetLeft;        // set x to elm’s offsetLeft
                let y = elm.offsetTop;         // set y to elm’s offsetTop

                elm = elm.offsetParent;    // set elm to its offsetParent

                //use while loop to check if elm is null
                // if not then add current elm’s offsetLeft to x, offsetTop to y and set elm to its offsetParent
                while (elm != null) {
                    x = parseInt(x) + parseInt(elm.offsetLeft);
                    y = parseInt(y) + parseInt(elm.offsetTop);
                    elm = elm.offsetParent;
                }

                // returns an object with "xp" (Left), "=yp" (Top) position
                return {'xp': x, 'yp': y};
            },

            // Returns object with X, Y coords inside its parent
            getCoords(e) {
                let target = e.target;
                while (target.tagName != "TABLE") {
                    target = target.parentElement;
                }
                if (target.tagName != "TABLE") {
                    return;
                }
                var xy_pos = this.getXYpos(target);

                let x = e.pageX;
                let y = e.pageY;

                x = x - xy_pos['xp'];
                y = y - xy_pos['yp'];

                return {'xp': x, 'yp': y};
            },

            displayFloat(e) {
                if(this.nableFloating === false){
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                let mouseXY = this.getCoords(e);
                if (document.getElementsByClassName("floating")[0]) {
                    document.getElementsByClassName("floating")[0].style.left = mouseXY.xp + 20 + 'px';
                    document.getElementsByClassName("floating")[0].style.top = mouseXY.yp - 50 + 'px';
                }
            },

            hideFloat(e) {
                if(this.enableFloating === false){
                    return;
                }
                e.preventDefault();
                e.stopPropagation();
                if (document.getElementsByClassName("floating")[0]) {
                    document.getElementsByClassName("floating")[0].style.display = "none";
                }
                setTimeout(() => {
                    this.showFloat(e)
                }, 500)
            },
            showFloat(e) {
                setTimeout(() => {
                    if(this.enableFloating === false){
                    return;
                }
                    e.preventDefault();
                    e.stopPropagation();
                    if (document.getElementsByClassName("floating")[0]) {
                        document.getElementsByClassName("floating")[0].style.display = "flex";
                    }
                }, 500)
                
            },
        },
    }
</script>

<style scoped>
    .search-result-table {
        border-spacing: 0;
        padding-bottom: 1em;
        width: 100%;
        margin-top: 1em;
        position: relative;
    }

    .table-header-row {
        height: 3em;
        background: #F6F6F6;
    }

    .table-header-row th {
        text-align: left;
        padding: 1em;
    }

    .table-result-row {
        height: 3em;
        font-weight: 500;
        color: #333333;
        position: relative;
    }

    .table-result-row td {
        border-bottom: 1px solid #EBEBEB;
        padding: 1em;
        text-align: left;
        position: relative;
    }

    .btn-detail {
        color: #0171A3;
    }

    .btn-delete {
        color: #FD1F58;
    }

    .pagination {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 0.5em 1em;
        text-decoration: none;
    }

    .number-button {
        display: flex;
        width: 2.2em;
        height: 2.2em;
        background: #FFFFFF;
        border: 1px solid #DCE0E5;
        border-radius: 5px;
        align-items: center;
        justify-content: center;
        margin: 0 5px;
        cursor: pointer;
    }

    .blank-button {
        display: flex;
        width: 2.2px;
        height: 2.2px;
        align-items: center;
        justify-content: center;
        margin: 0 5px;
    }

    .number-button:hover {
        background: #018AC7;
        color: white;
    }

    .radio-hidden {
        display: none;
    }

    .radio-hidden:checked + label {
        background: #0171A3;
        color: white;
    }

    .nav-button {
        display: inline-block;
    }

    .floating {
        display: none;
        position: absolute;
        border: 1px solid #0171A3;
        border-radius: 5px;
        width: 80px;
        background: white;
        z-index: 99;
        align-items: center;
        padding: 0.5em;
    }
</style>